import React, {useEffect, useState, useCallback} from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { faEye, faEyeSlash, faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import '../../assets/stylesheets/PasswordRecovery.scss';


const RecoverySuccess = ({ }) => {
    const { t } = useTranslation();
    return (
        <div className='recoverySuccess'>
            <div className={'logoSection'}>
                <div className={'recoveryLogo'}></div>
                <span className={'recoveryDescription'}>{t('passwordRecovery.successDescription')}</span>
            </div>
            
            <div className={`backSection`}>
                <Link to={'/login'} className={`goBack`}> {t('passwordRecovery.goBack')}</Link>
            </div>
        </div>
    );
};

export default RecoverySuccess;
